<template>
  <div class="address-information">
    <div class="row header">
      <div class="col-12 mb-3 mt-2">
        <em
          class="fas rounded-circle p-1 mr-2 color-green shadow bg-white"
          :class="editModel.isNew ? 'fa-plus' : 'fa-edit'"
        />
        <span>{{ editModel.isNew ? 'Añadir' : 'Editar' }} Dirección</span>
      </div>
    </div>
    <div class="row body">
      <div class="col">
        <div class="col-sm-12">
          <validation-observer ref="formValidator">
            <address-information
              v-model="editModel"
              :address-types="availableAddressTypes"
              :fiscal-year-id="fiscalYearId"
            />
          </validation-observer>
        </div>
        <div class="col-sm-12 pr-0">
          <div class="row">
            <div class="col-sm-12 offset-md-6 col-md-6 text-right pb-3">
              <action-button
                class="mr-2 py-2 w-19 btnCancel"
                i="fas fa-times-circle"
                text="Cancelar"
                variant="outline-danger"
                @click="cancel"
              />
              <action-button
                class="py-2 w-18"
                i="fas fa-save"
                text="Guardar"
                variant="success"
                @click="save"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import AddressInformation from './AddressInformation';

import alert from '@/mixins/alert.mixin';

export default {
  name: 'AddressInformationAddEdit',
  components: {
    AddressInformation,
  },
  mixins: [alert],
  props: {
    value: {
      type: Object,
      default: () => ({}),
    },
    disablePrimary: {
      type: Boolean,
      default: () => false,
    },
    addressTypes: {
      type: Array,
      default: () => [],
    },
    fiscalYearId: {
      type: Number,
      default: () => null,
    },
  },
  data() {
    return {
      editModel: Object.assign({}, this.value), //Copy the model to eliminate the reference
      isPrimaryInitiallySelected: false,
    };
  },
  computed: {
    availableAddressTypes() {
      return this.addressTypes;
    },
  },
  watch: {
    value: function(newValue) {
      this.editModel = Object.assign({}, newValue); //Copy the model to eliminate the reference
    },
  },
  methods: {
    async save() {
      const isValid = await this.$refs.formValidator.validate();

      if (isValid) {
        this.$emit('on-saved', this.editModel);
      } else {
        //TODO: Use the stored one
        this.ShowToast('Error', 'Información incompleta. (190803)', 'error');
      }
    },
    async cancel() {
      this.$emit('on-cancel');
    },
  },
};
</script>
<style scoped>
@media (min-width: 576px) {
  .address-information .header {
    padding-left: 0.25 !important;
    padding-right: 0.25 !important;
  }

  .address-information .body {
    padding-left: 0.43 !important;
    padding-right: 0.43 !important;
  }

  .address-information .btnCancel {
    float: left;
  }
}

@media (min-width: 768px) {
  .address-information .header {
    padding-left: 0.33rem !important;
    padding-right: 0.33rem !important;
  }

  .address-information .body {
    padding-left: 1rem !important;
    padding-right: 1rem !important;
  }

  .address-information .btnCancel {
    float: inherit;
  }
}

@media (min-width: 992px) {
  .address-information .header {
    padding-left: 0.66rem !important;
    padding-right: 0.66rem !important;
  }

  .address-information .body {
    padding-left: 1.75rem !important;
    padding-right: 1.75rem !important;
  }
}

@media (min-width: 1200px) {
  .address-information .header {
    padding-left: 1rem !important;
    padding-right: 1rem !important;
  }

  .address-information .body {
    padding-left: 3rem !important;
    padding-right: 3rem !important;
  }
}
</style>
